export const STANDARD_INCLUSION_TYPE = {
  FREE_TEXT: 'FREE_TEXT',
  ONBOARD_CREDIT: 'ONBOARD_CREDIT',
} as const

export type InclusionType = typeof STANDARD_INCLUSION_TYPE[keyof typeof STANDARD_INCLUSION_TYPE]

export function sortByInclusionPriority(a: App.PackageInclusion, b: App.PackageInclusion): number {
  if (a.isHighlighted && !b.isHighlighted) return -1
  if (!a.isHighlighted && b.isHighlighted) return 1
  if (a.parentCategory === STANDARD_INCLUSION_TYPE.ONBOARD_CREDIT && b.parentCategory !== STANDARD_INCLUSION_TYPE.ONBOARD_CREDIT) return -1
  if (a.parentCategory !== STANDARD_INCLUSION_TYPE.ONBOARD_CREDIT && b.parentCategory === STANDARD_INCLUSION_TYPE.ONBOARD_CREDIT) return 1
  return 0
}
